import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { UpCircleOutlined } from "@ant-design/icons";
import classname from "classname";

const Upgrade = ({
  id = "btn-upgrade",
  title,
  icon = <UpCircleOutlined />,
  type = "primary",
  onClick = () => {},
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.upgrade");

  return (
    <Button
      className={classname("flex items-center hover:opacity-70", className)}
      style={
        !props?.disabled
          ? { backgroundColor: "#46be8a", borderColor: "#6ccba2" }
          : {}
      }
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(Upgrade);
